import React from 'react';
import Edit from '../../../containers/rest/Edit';
import Form from '../components/Form';

const LeadersEdit = props => (
  <Edit {...props} resource="leaders">
    <Form />
  </Edit>
);

LeadersEdit.propTypes = {};

export default LeadersEdit;
